import React, { useState, useEffect } from 'react';
import { X } from 'lucide-react';

// ─── REEMPLAZÁ ESTE NÚMERO CUANDO DANIEL TENGA EL CHIP ───────────────────────
// Formato: código de país + número sin espacios ni guiones
// Argentina: 54 + código de área sin 0 + número sin 15
// Ejemplo CABA: 5491154321234 (para el número 011 15-4321-2345)
const WHATSAPP_NUMBER = '54911XXXXXXXX';

// Mensaje pre-cargado cuando el visitante toca el botón
const WHATSAPP_MESSAGE = encodeURIComponent('Hola, vi el Kit Blindaje Total Argentina y tengo una consulta antes de comprarlo 👋');
const WHATSAPP_URL = `https://wa.me/${WHATSAPP_NUMBER}?text=${WHATSAPP_MESSAGE}`;
export function WhatsAppButton() {
  // La burbuja aparece automáticamente a los 4 segundos
  const [showBubble, setShowBubble] = useState(false);
  // Control para cuando el usuario cierra la burbuja manualmente
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    if (dismissed) return;
    const timer = setTimeout(() => setShowBubble(true), 4000);
    return () => clearTimeout(timer);
  }, [dismissed]);
  const handleDismiss = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    setShowBubble(false);
    setDismissed(true);
  };
  return <>
      {/* ── ESTILOS CSS ── */}
      <style data-id="element-652">{`
        /* Glow pulsante del botón */
        @keyframes wa-glow {
          0%   { box-shadow: 0 0 0 0 rgba(37, 211, 102, 0.7), 0 4px 20px rgba(37, 211, 102, 0.4); }
          50%  { box-shadow: 0 0 0 12px rgba(37, 211, 102, 0), 0 4px 28px rgba(37, 211, 102, 0.6); }
          100% { box-shadow: 0 0 0 0 rgba(37, 211, 102, 0.7), 0 4px 20px rgba(37, 211, 102, 0.4); }
        }

        /* Ícono de WhatsApp: escala suave */
        @keyframes wa-icon-pulse {
          0%, 100% { transform: scale(1); }
          50%       { transform: scale(1.08); }
        }

        /* Burbuja: entrada desde abajo */
        @keyframes wa-bubble-in {
          from { opacity: 0; transform: translateY(10px) scale(0.95); }
          to   { opacity: 1; transform: translateY(0) scale(1); }
        }

        /* Ping del punto verde en la burbuja */
        @keyframes wa-ping {
          0%   { transform: scale(1); opacity: 1; }
          75%, 100% { transform: scale(2); opacity: 0; }
        }

        .wa-btn {
          animation: wa-glow 2.2s ease-in-out infinite;
        }
        .wa-btn:hover {
          transform: scale(1.1) !important;
          animation: none;
          box-shadow: 0 0 0 14px rgba(37, 211, 102, 0), 0 6px 32px rgba(37, 211, 102, 0.7) !important;
        }
        .wa-icon {
          animation: wa-icon-pulse 2.2s ease-in-out infinite;
        }
        .wa-bubble {
          animation: wa-bubble-in 0.35s cubic-bezier(0.34, 1.56, 0.64, 1) forwards;
        }
        .wa-ping-dot::after {
          content: '';
          position: absolute;
          inset: 0;
          border-radius: 50%;
          background: #25D366;
          animation: wa-ping 1.5s cubic-bezier(0, 0, 0.2, 1) infinite;
        }
      `}</style>

      {/* ── CONTENEDOR FIJO ── */}
      <div style={{
      position: 'fixed',
      bottom: 28,
      right: 24,
      zIndex: 9999,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-end',
      gap: 10
    }} data-id="element-653">
        {/* ── BURBUJA DE MENSAJE ── */}
        {showBubble && <div className="wa-bubble" style={{
        position: 'relative',
        background: '#FFFFFF',
        borderRadius: '16px 16px 4px 16px',
        padding: '12px 36px 12px 16px',
        boxShadow: '0 4px 24px rgba(0,0,0,0.14), 0 1px 4px rgba(0,0,0,0.08)',
        maxWidth: 220,
        cursor: 'default'
      }} data-id="element-654">
            {/* Punto verde online */}
            <div style={{
          display: 'flex',
          alignItems: 'center',
          gap: 6,
          marginBottom: 4
        }} data-id="element-655">
              <div className="wa-ping-dot" style={{
            position: 'relative',
            width: 8,
            height: 8,
            borderRadius: '50%',
            background: '#25D366',
            flexShrink: 0
          }} data-id="element-656" />
              <span style={{
            fontSize: 10,
            fontWeight: 700,
            color: '#25D366',
            textTransform: 'uppercase',
            letterSpacing: '0.06em',
            fontFamily: 'inherit'
          }} data-id="element-657">
                Digital Solvex
              </span>
            </div>

            {/* Texto */}
            <p style={{
          margin: 0,
          fontSize: 14,
          fontWeight: 600,
          color: '#1A1A2E',
          lineHeight: 1.4,
          fontFamily: 'inherit'
        }} data-id="element-658">
              ¿Tenés alguna duda?
            </p>
            <p style={{
          margin: '3px 0 0',
          fontSize: 12,
          color: '#777',
          lineHeight: 1.4,
          fontFamily: 'inherit'
        }} data-id="element-659">
              Escribinos por WhatsApp
            </p>

            {/* Botón cerrar */}
            <button onClick={handleDismiss} style={{
          position: 'absolute',
          top: 8,
          right: 8,
          width: 20,
          height: 20,
          borderRadius: '50%',
          background: '#F0F0F0',
          border: 'none',
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: 0
        }} data-id="element-660">
              <X style={{
            width: 10,
            height: 10,
            color: '#999'
          }} data-id="element-661" />
            </button>

            {/* Cola de la burbuja */}
            <div style={{
          position: 'absolute',
          bottom: -8,
          right: 18,
          width: 0,
          height: 0,
          borderLeft: '8px solid transparent',
          borderRight: '0px solid transparent',
          borderTop: '8px solid #FFFFFF',
          filter: 'drop-shadow(0 2px 2px rgba(0,0,0,0.08))'
        }} data-id="element-662" />
          </div>}

        {/* ── BOTÓN PRINCIPAL ── */}
        <a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer" className="wa-btn" onClick={() => setShowBubble(false)} style={{
        width: 60,
        height: 60,
        borderRadius: '50%',
        background: 'linear-gradient(135deg, #25D366 0%, #128C7E 100%)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        textDecoration: 'none',
        transition: 'transform 0.2s ease',
        flexShrink: 0
      }} aria-label="Chatear por WhatsApp" data-id="element-663">
          {/* SVG oficial de WhatsApp */}
          <svg className="wa-icon" viewBox="0 0 32 32" fill="white" style={{
          width: 32,
          height: 32
        }} xmlns="http://www.w3.org/2000/svg" data-id="element-664">
            <path d="M16.004 2.667C8.637 2.667 2.667 8.637 2.667 16c0 2.363.617 4.587 1.696 6.52L2.667 29.333l6.98-1.664A13.294 13.294 0 0016.004 29.333C23.37 29.333 29.333 23.363 29.333 16S23.37 2.667 16.004 2.667zm0 2.373c5.884 0 10.626 4.742 10.626 10.627S21.888 26.294 16.004 26.294a10.58 10.58 0 01-5.382-1.471l-.39-.23-4.046.963.984-3.937-.257-.408A10.55 10.55 0 015.377 16c0-5.884 4.742-10.96 10.627-10.96zm-3.045 5.458c-.21 0-.55.079-.84.395-.287.316-1.099 1.073-1.099 2.617s1.124 3.035 1.282 3.247c.156.21 2.196 3.352 5.325 4.57.743.32 1.323.512 1.776.655.745.237 1.425.204 1.962.124.598-.09 1.844-.754 2.106-1.481.26-.727.26-1.352.183-1.482-.078-.13-.286-.208-.6-.365-.314-.157-1.857-.916-2.144-1.02-.287-.104-.495-.156-.703.157-.208.313-.808 1.02-.989 1.228-.183.21-.365.234-.68.078-.314-.157-1.325-.488-2.525-1.558-.934-.831-1.564-1.856-1.747-2.17-.183-.313-.02-.482.138-.638.14-.14.314-.365.47-.548.157-.182.21-.312.314-.52.105-.21.053-.392-.026-.548-.08-.157-.704-1.697-.964-2.326-.254-.612-.514-.528-.703-.538-.182-.008-.392-.01-.601-.01z" data-id="element-665" />
          </svg>
        </a>
      </div>
    </>;
}